import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import SidebarSubSection from 'components/Onboarding/PWMSidebar/SidebarSubSection/SidebarSubSection'
import {
  successorCustodians as successorCustodiansConfig,
  beneficiaries as beneficiariesConfig
} from 'utils/contactTypes'
import {
  SCHWAB_ONE_PERSONAL,
  SCHWAB_IRA,
} from 'utils/financialAccountTypes'
import C from 'actionTypes/routing'

const custodialAccountTypes = [
  SCHWAB_IRA.ACCOUNT_TYPES.CUSTODIAL_IRA,
  SCHWAB_IRA.ACCOUNT_TYPES.CUSTODIAL_ROTH_IRA,
]

const PersonalAccountFormSection = (props) => {
  const {
    financialAccountType,
    financialAccountId,
    hasJointOwner,
    sectionsOverview,
    financialAccount,
  } = props
  const sharedProps = {
    financialAccountType,
    financialAccountId,
  }
  const { subType } = financialAccount.attributes
  const isUTMA = subType === SCHWAB_ONE_PERSONAL.ACCOUNT_TYPES.UTMA
  const isCustodial = custodialAccountTypes.includes(subType)

  return (
    <Fragment>
      <SidebarSubSection
        sectionComplete={sectionsOverview.accountDetails.complete}
        to={{
          type: C.ONBOARDING_ACCOUNT_DETAILS,
          payload: sharedProps
        }}
        name="Details" />
      { hasJointOwner &&
        <SidebarSubSection
          sectionComplete={sectionsOverview.jointOwner.complete}
          to={{
            type: C.ONBOARDING_JOINT_OWNER,
            payload: sharedProps
          }}
          name="Joint Account Holder" />
      }
      {
        (isUTMA || isCustodial) && (
          <SidebarSubSection
            sectionComplete={sectionsOverview.successorCustodians.complete}
            to={{
              type: C.ONBOARDING_CONTACTS_PAGE,
              payload: {
                ...sharedProps,
                contactType: successorCustodiansConfig.routeType
              }
            }}
            name={successorCustodiansConfig.DISPLAY} />
        )
      }
      {
        !isUTMA &&
        <SidebarSubSection
          sectionComplete={sectionsOverview.beneficiaries.complete}
          to={{
            type: C.ONBOARDING_CONTACTS_PAGE,
            payload: {
              ...sharedProps,
              contactType: beneficiariesConfig.routeType
            }
          }}
          name={beneficiariesConfig.DISPLAY} />
      }
    </Fragment>
  )
}

PersonalAccountFormSection.propTypes = {
  financialAccount: PropTypes.object.isRequired,
  financialAccountId: PropTypes.string.isRequired,
  hasJointOwner: PropTypes.bool,
  financialAccountType: PropTypes.string.isRequired,
  accountDetailsComplete: PropTypes.bool,
  jointAccountHolderComplete: PropTypes.bool,
  successorCustodianComplete: PropTypes.bool,
  sectionsOverview: PropTypes.object.isRequired,
}

PersonalAccountFormSection.defaultProps = {
  hasJointOwner: false,
  accountDetailsComplete: false,
  jointAccountHolderComplete: false,
  successorCustodianComplete: false,
}

export default PersonalAccountFormSection



// WEBPACK FOOTER //
// ./src/components/Onboarding/PWMSidebar/FinancialAccountFormGroup/FinancialAccountFormSection/PersonalAccountFormSection.jsx